import { isRadioButton } from './utils';
var RadioGroupController = /** @class */ (function () {
    function RadioGroupController(controlledComponent, node) {
        var _this = this;
        this.controlledComponent = controlledComponent;
        this.node = node;
        this.node.addEventListener('awsui:change', function (ev) {
            if (isRadioButton(ev.target)) {
                _this.controlledComponent.value = ev.detail.value;
                // Re-fire `awsui:change` event with different target.
                _this.controlledComponent.__fireEvent('change', { value: _this.controlledComponent.value });
                ev.stopPropagation();
            }
        });
        this.controlledComponent.__listenToPropertyChanges('value', function (newValue, element) {
            if (!isRadioButton(element)) {
                return;
            }
            // Check or uncheck the radio depending on our current value
            element.component.checked = element.component.value === _this.controlledComponent.value;
        });
    }
    RadioGroupController.prototype.handleValueChange = function () {
        var buttons = this.node.querySelectorAll('awsui-radio-button');
        for (var _i = 0, buttons_1 = buttons; _i < buttons_1.length; _i++) {
            var button = buttons_1[_i];
            button.component.checked = button.component.value === this.controlledComponent.value;
        }
    };
    return RadioGroupController;
}());
export { RadioGroupController };
//# sourceMappingURL=controller.js.map